import styled from 'styled-components'
import { spacing, colors, font } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import { SecondaryButton } from '@chegg-ui/button'

export const SuggestionCardWrapper = styled.div<{ isExpanded: boolean }>`
  border-radius: ${({ isExpanded }) => (isExpanded ? '10px' : '12px')};
  padding: ${spacing.px16};
  border: 1px solid ${({ isExpanded }) => (isExpanded ? `${colors.grey900}` : '#e9e9eb')};
  max-width: 375px;
  margin: ${spacing.px8} 0;
  cursor: pointer;
`

export const SuggestionCardText = styled(Typography).attrs({
  variant: 'body1',
  variantType: 'paragraph',
})<{ isTruncated?: boolean; isExpanded?: boolean }>`
  ${({ isTruncated = false }) =>
    isTruncated
      ? `
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: pre-wrap;
  text-align: left;
  `
      : ``}

  ${({ isExpanded = false }) => (isExpanded ? `cursor: text` : `cursor: pointer`)}
`

export const SuggestionCardTitle = styled.div<{ isExpanded: boolean }>`
  cursor: pointer;
  ${({ isExpanded }) =>
    isExpanded
      ? `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  `
      : `
    display: flex;
    flex-direction: column;
    row-gap: ${spacing.px8};
  `}
`

export const NoThanksCTA = styled(SecondaryButton).attrs({
  variant: 'text',
  size: 'small',
})`
  padding: 5.6px ${spacing.px16} 5.6px ${spacing.px16};
  cursor: pointer;
  && {
    color: ${({ disabled }) => (disabled ? colors.grey500 : colors.grey700)};
    font-size: ${font.size.px14};
    font-weight: ${font.weight.bold};
  }
  ${({ disabled }) =>
    disabled
      ? ''
      : `
    &&:hover,
    &&:focus {
      background-color: #eeeef1;
      color: ${colors.grey900};
    }
  `};
`
